// import { animate } from 'popmotion';

(() => {
    const buttons = document.querySelectorAll('.homepage-header__button-container .button');

    let width = 0;
    buttons.forEach((button) => {
        width = Math.max(width, button.getBoundingClientRect().width);
    });

    buttons.forEach((button) => {
        button.style.minWidth = `${width}px`;
    });
})();

/*
(() => {
    const header = document.querySelector('[data-homepage-header]');
    const mouse = document.querySelector('[data-homepage-header-mouse]');

    if (header && mouse) {
        mouse.addEventListener('click', () => {
            animate({
                from: window.pageYOffset,
                to: window.pageYOffset + header.getBoundingClientRect().bottom,
                onUpdate: value => window.scrollTo(0, value),
            });
        });
    }
})();
 */
